import React from 'react';
import AssessmentPreparation from 'Views/InterviewCandidates/Docs/AssessmentPreparation';

const ProgrammingAssessmentPreparation = () => {
    return <AssessmentPreparation assessmentName='Programming Assessment' />;
};

export default ProgrammingAssessmentPreparation;
